import React from 'react';
import { PapiUser } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import {
  BiContextProvidedValue,
  BiData,
  AddToGroupSelectBiEvent,
} from '@wix/da-bi/pkg/events';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import RecommendedIcon from '@wix/da-ds/pkg/Icons/Recommended';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import StreamedList from '../../../StreamedList';
import BasicUserAvatar from '../../../User/_partials/BasicUserAvatar';
import { recommendedGroupsStreamId } from '../../redux/constants';
import s from './GroupsList.scss';

export interface RecommendedGroupListProps {
  recommendedGroups: PapiUser[];
  deviationId: number;
  filterValue?: string;
  onSelect: (group: PapiUser) => void;
}

const RecommendedGroupList: React.FC<RecommendedGroupListProps> = ({
  recommendedGroups,
  deviationId,
  filterValue,
  onSelect,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={s['recommended-groups-description']}>
        {t('addToGroupPopup.recommended.subtitle')}
      </div>
      <div className={s['recommended-groups-header']}>
        <RecommendedIcon size={IconSize.SMALLER} />
        <Heading className={s['recommended-groups-title']}>
          {t('networkBar.subheader.recommendedGroups')}
        </Heading>
      </div>
      <StreamedList
        streamId={recommendedGroupsStreamId}
        className={s['list']}
        wrapperClassName={s['scrollable']}
      >
        {recommendedGroups.map(group =>
          !filterValue ||
          group.username.toLowerCase().includes(filterValue.toLowerCase()) ? (
            <ListItemButton
              key={group.userId}
              onClick={() => onSelect(group)}
              biData={BiData<AddToGroupSelectBiEvent>({
                evid: 341,
                deviationid: deviationId,
                groupid: group.useridUuid,
                source_type: BiContextProvidedValue,
              })}
              label={group.username}
              prefix={<BasicUserAvatar user={group} size={35} />}
              suffix={
                <GhostButton
                  variant="main"
                  size="medium"
                  href={Url.userLink(group.username)}
                  className={s['visit-group-button']}
                >
                  {t('networkBar.groups.group.actions.visit')}
                </GhostButton>
              }
              fillContainerWidth
              showSuffixOnlyOnHover
            />
          ) : null
        )}
      </StreamedList>
    </>
  );
};
RecommendedGroupList.displayName = 'RecommendedGroupList';

export default RecommendedGroupList;
